import services from './../../services/service'; // Service Class
let service = new services();

export default {
  name: "MainHeader",
  data() {
      return {
        user: '', 
        user_slug: {},
        sellpoint:{},
        img_url: service.imageURL,
        loggedIn:false
      }
  },
  computed: {
    total() {
      var total = 0;
      for(var i = 0; i < this.items.length; i++) {
        total += this.items[i].product_price;
      }
      return total;
    }
},
methods: {
    checkLoggedIn(){
        if(localStorage.getItem("sp_token") != null){
            this.loggedIn = true;
            this.user = localStorage.getItem("sp_user");
        }
    },

    setSellpoint(){
        service.getAppBusinessByUserName(this, service.business_app_name).then(response => {
            if(response.body.status == 200) {
                this.sellpoint = response.body.data;
            }
        }).catch((err) => {
            //maybe no connection ..load from local
           // this.setSellpointLocal(); //removed...caused slower loading
        })
        
    },


    setMarketLocal(){},

    
  },
  created: function() {
    this.checkLoggedIn();
    this.setSellpoint();
  }
}


// WEBPACK FOOTER //
// ./src/pages/MainHeader/script.js